define(["exports", "./utils", "text!../../assets/examples.css", "../core/l10n", "hyperhtml", "./pubsubhub"], function (_exports, _utils, _examples, _l10n, _hyperhtml, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _examples = _interopRequireDefault(_examples);
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["\n        <div class=\"example\" id=\"", "\">\n          ", " ", "\n        </div>\n      "]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["\n      <style>\n        ", "\n      </style>\n    "]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n    <div class=\"marker\">\n      <a class=\"self-link\">", "<bdi>", "</bdi></a\n      >", "\n    </div>\n  "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n        <span class=\"example-title\">: ", "</span>\n      "]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/examples";
  _exports.name = name;
  const localizationStrings = {
    en: {
      example: "Example"
    },
    nl: {
      example: "Voorbeeld"
    },
    es: {
      example: "Ejemplo"
    }
  };
  const lang = _l10n.lang in localizationStrings ? _l10n.lang : "en";
  const l10n = localizationStrings[lang];
  /**
   * @typedef {object} Report
   * @property {number} number
   * @property {boolean} illegal
   * @property {string} [title]
   * @property {string} [content]
   *
   * @param {HTMLElement} elem
   * @param {number} num
   * @param {Report} report
   */

  function makeTitle(elem, num, report) {
    report.title = elem.title;
    if (report.title) elem.removeAttribute("title");
    const number = num > 0 ? " ".concat(num) : "";
    const title = report.title ? (0, _hyperhtml.default)(_templateObject(), report.title) : "";
    return (0, _hyperhtml.default)(_templateObject2(), l10n.example, number, title);
  }

  function run() {
    /** @type {NodeListOf<HTMLElement>} */
    const examples = document.querySelectorAll("pre.example, pre.illegal-example, aside.example");
    if (!examples.length) return;
    document.head.insertBefore((0, _hyperhtml.default)(_templateObject3(), _examples.default), document.querySelector("link"));
    let number = 0;
    examples.forEach(example => {
      const illegal = example.classList.contains("illegal-example");
      /** @type {Report} */

      const report = {
        number,
        illegal
      };
      const {
        title
      } = example;

      if (example.localName === "aside") {
        ++number;
        const div = makeTitle(example, number, report);
        example.prepend(div);

        if (title) {
          (0, _utils.addId)(example, "example-".concat(number), title); // title gets used
        } else {
          // use the number as the title... so, e.g., "example-5"
          (0, _utils.addId)(example, "example", String(number));
        }

        const {
          id
        } = example;
        const selfLink = div.querySelector("a.self-link");
        selfLink.href = "#".concat(id);
        (0, _pubsubhub.pub)("example", report);
      } else {
        const inAside = !!example.closest("aside");
        if (!inAside) ++number;
        report.content = example.innerHTML; // wrap

        example.classList.remove("example", "illegal-example"); // relocate the id to the div

        const id = example.id ? example.id : null;
        if (id) example.removeAttribute("id");
        const exampleTitle = makeTitle(example, inAside ? 0 : number, report);
        const div = (0, _hyperhtml.default)(_templateObject4(), id, exampleTitle, example.cloneNode(true));

        if (title) {
          (0, _utils.addId)(div, "example-".concat(number), title);
        }

        (0, _utils.addId)(div, "example", String(number));
        const selfLink = div.querySelector("a.self-link");
        selfLink.href = "#".concat(div.id);
        example.replaceWith(div);
        if (!inAside) (0, _pubsubhub.pub)("example", report);
      }
    });
  }
});
//# sourceMappingURL=examples.js.map